// extracted by mini-css-extract-plugin
module.exports = {"Graphic":"_3qk7BMMJ","QuoteContainer":"_9l678NNy","QuoteContainerOne":"_32kbZZtB","Person":"_3M_DL-Br","Avatar":"_2onGD0ZW","Info":"_2sZjM7U_","Name":"_3ZepofRV","Role":"_2YZbhCNq"};
    if(module.hot) {
      // 1746735793303
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  